import { useTranslation } from 'react-i18next';

import {
  AddTask,
  Delete,
  StickyNote2,
  VButton,
  VFlex,
  VStack,
  VTabTrigger,
  VTabTriggerContainer,
  useVModal,
} from '@/package';
import { VIconButton } from '@/package/kiska/src/component/UI/VIconButton';
import { useTaskListContext } from '@/provider';

const TaskListPageAction = ({
  showTaskCreationDrawer,
}: {
  showTaskCreationDrawer: () => void;
}) => {
  const { openDangerConfirm } = useVModal();
  const { selectedTaskIDList, removeTaskList } = useTaskListContext();
  const { t } = useTranslation();

  return (
    <VStack className="w-full">
      <VFlex className="py-4" justify="between">
        <VTabTriggerContainer>
          <VTabTrigger value="1"> List </VTabTrigger>
          <VTabTrigger value="2"> Statistics </VTabTrigger>
          <VTabTrigger value="3"> Overview </VTabTrigger>
        </VTabTriggerContainer>

        <VFlex gap={1} items="center">
          <VButton
            size="lg"
            type="button"
            onClick={() => showTaskCreationDrawer()}
          >
            <AddTask className="h-5 w-5" />
            {t('task.createTaskButtonText.reiteration')}
          </VButton>

          <VIconButton
            variant="danger"
            size="md"
            disabled={!selectedTaskIDList?.length}
            Icon={Delete}
            onClick={() => {
              openDangerConfirm({
                title: () => (
                  <div className="translate-y-1 text-body-xl text-error-500">
                    Delete Task
                  </div>
                ),
                message: () => (
                  <VFlex direction="col" className="gap-[10px]">
                    <div className="text-body-xl text-black">
                      All data will be permanently deleted. Are you sure you
                      want to proceed?
                    </div>

                    <VFlex className="items-center gap-1 text-gray-500">
                      <StickyNote2 className="h-4 w-4" />
                      <div className="w-full flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
                        {selectedTaskIDList?.length ?? 0} tasks
                      </div>
                    </VFlex>
                  </VFlex>
                ),
                confirmText: 'Delete',
                onConfirm: () => {
                  removeTaskList(selectedTaskIDList);
                },
              });
            }}
          />
        </VFlex>
      </VFlex>
    </VStack>
  );
};

export default TaskListPageAction;
